<template>
  <div class="gender">
    <div class="r-text-intro">פרטים אישיים | כמו שמופיעים בת.ז.</div>
    <div class="form">
      <div class="r-text-headline-paragraph">מין*</div>
      <gender-selection-image-button :gender-enum="Gender" @input="setGenderAndProceed"/>
      <div class="r-text-disclaimer gender-disclaimer">* אנחנו שואלים רק בשביל אימות תעודת הזהות</div>
    </div>
  </div>
</template>

<script>
import WizardPage from '@/mixins/WizardPage';
import { mapState, mapMutations } from 'vuex';
import { Gender } from '@/constants/meitav-dash/open-fund';
import GenderSelectionImageButton from '@/components/styled/GenderSelectionImageButton';
import Segment from '@/Segment';

export default {
  name: 'Gender',
  components: { GenderSelectionImageButton },
  mixins: [WizardPage],
  computed: {
    ...mapState('meitavDash/openFund', ['gender']),
    Gender() {
      return Gender;
    },
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setGender']),
    async setGenderAndProceed(gender) {
      Segment.trackUserInteraction('Saving_GenderClicked', { gender });
      this.setGender(gender);
      await this.nextPage();
    },
  },
};
</script>

<style scoped lang="scss">
.gender-disclaimer {
  margin-top: 16px;
}
</style>
